import { ElementType } from 'react';

export type VideoEffectsOptionsProps = {
  label: string;
  translate: string;
  value: 'blur' | 'image' | null;
  editComponent?: ElementType;
};

export enum InputOutputSection {
  MICROPHONE = 'microphone',
  SPEAKER = 'speaker',
  CAMERA = 'camera',
}
